import { BaseModalContext } from '@alfalab/core-components-base-modal/esm';

var ModalContext = BaseModalContext;

export { ModalContext };
